/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { extendTheme, rebrandingTheme } from '@getgo/chameleon-chakra-ui';
import { Dict } from '@chakra-ui/utils';
import {
  darkGotoAppColors,
  lighGotoAppColors as lightGotoAppColors,
} from '@getgo/chameleon-core';

//Spacings suggested by chameleon core https://gtc.devops.jive.com/chameleon/dev/foundation/
export enum Spacing {
  XSmall = '8px',
  CoreLayout1 = '16px',
  CoreLayout2 = '24px',
  CoreLayout3 = '32px',
  CoreLayout4 = '48px',
  CoreLayout5 = '64px',
  CoreLayout6 = '96px',
  CoreLayout7 = '160px',
}

export enum Opacity {
  Medium = '67%',
}

export enum FontWeight {
  Medium = 600,
}
export enum ColorTheme {
  dark = 'dark',
  light = 'light',
}

export const GoToTheme = (colorTheme: ColorTheme): Dict<any> => {
  const themeToColorTokens: { [key in ColorTheme]: Dict<any> } = {
    [ColorTheme.dark]: darkGotoAppColors,
    [ColorTheme.light]: lightGotoAppColors,
  };
  return extendTheme(
    {
      styles: {
        global: {
          'html, body, #root, #app, #scrollcushion': {
            height: '100%',
            width: '100%',
            margin: '0',
            padding: '0 !important',
          },
          html: {
            border: 'none',
            boxSizing: 'content-box',
          },
          '#app': {
            overflow: 'auto',
          },
          '*::-ms-backdrop, #app': {
            height: '421px',
            minHeight: '100%',
          },
          '*::-ms-backdrop, #footer': {
            bottom: 0,
            position: 'absolute',
          },
          '*::-ms-backdrop, #checkmark': {
            height: '22px',
            width: '22px',
          },
          '*::-ms-backdrop, #calloutContainer': {
            display: 'block',
            padding: '2vh 5vh 3vh',
            maxWidth: '517px',
          },
          '*::-ms-backdrop, #selfHelpBox': {
            paddingTop: '15rem',
          },
        },
      },
    },
    extendTheme({ colors: themeToColorTokens[colorTheme] }, rebrandingTheme)
  );
};
